import { ts } from 'src/utils/translate';
import { TableCell } from 'src/pages/OfferPage/TableSvgOrganizer/TableCell';
import { RowTools } from 'src/pages/OfferPage/TableSvgOrganizer/RowTools/RowTools';
import { CustomCell } from 'src/pages/OfferPage/TableSvgOrganizer/CustomCell';
import { formatPriceForcedCurrency } from 'src/utils/formatPrice';
import { useParams } from 'react-router';
import { hasPermissionForFuncInProject } from 'src/utils/controllerHasPermissionsAdapter';
import { sendCustomItem, sendFetchedItem } from "src/utils/CustomRowUtils";
import {
  useAddCableCustomItemMutation,
  useAddConventionalDevicesCustomItemMutation,
  useAddElectricalCustomItemMutation,
  useAddNhcCustomItemMutation,
  useAddProjectCustomItemMutation,
  useAddRackCabinetCustomItemMutation,
  useAddRoomCustomItemMutation
} from "src/api/v1/quote-ApiSlice";
import { Autocomplete, TextField } from "@mui/material";
import { GetAllManufacturerDiscountForProjectResponse } from "src/model/api/manufacturer-discount.model";
import { ManufacturerRecommendationResponse } from "src/model/api/manufacturer-recommendation";
import { ManufacturerRecommendationForUser } from "src/model/manufacturer-recommendation-project";
import { Product } from "src/model/product.model";
import { Fragment, useCallback, useEffect, useState } from 'react';
import { useAddCustomSectionItemMutation } from "src/api/v1/section-ApiSlice"
import { ManufacturerAutocomplete } from "src/pages/OfferPage/TableSvgOrganizer/ManufacturerAutocomplete";

export const CustomRow = (
    {
      neededCols,
      cancelCustomRow,
      entityType,
      entityId,
      currency,
      dispatchDownloadStates,
      setCustomRowButtonPressed,
      setCurrentRowInEditing,
      allManufacturerDiscountForProject,
      manufacturerRecommendationForProject,
      customItemsForRecommendation
    }: {
      neededCols: any;
      cancelCustomRow: () => void;
      entityType: any;
      entityId: any;
      currency: string;
      dispatchDownloadStates: any;
      setCustomRowButtonPressed: any;
      setCurrentRowInEditing: any;
      allManufacturerDiscountForProject: GetAllManufacturerDiscountForProjectResponse;
      manufacturerRecommendationForProject: ManufacturerRecommendationResponse;
      customItemsForRecommendation: Product[];
    }
) => {

  const [ addRoomCustomItem ] = useAddRoomCustomItemMutation();
  const [ addProjectCustomItem ] = useAddProjectCustomItemMutation();
  const [ addElectricalCustomItem ] = useAddElectricalCustomItemMutation();
  const [ addNhcCustomItem ] = useAddNhcCustomItemMutation();
  const [ addCustomSectionItem ] = useAddCustomSectionItemMutation();
  const [ addRackCabinetCustomItem ] = useAddRackCabinetCustomItemMutation();
  const [ addCableCustomItem ] = useAddCableCustomItemMutation();
  const [ addConventionalDevicesCustomItem ] = useAddConventionalDevicesCustomItemMutation();

  const params = useParams<{ projectId: string }>();

  const [showTools, setShowTools] = useState<boolean|null>(null);
  const [customItem, setCustomItem] = useState<any>({ quantity: "1" });
  const [successResponse, setSuccessResponse] = useState(null);
  const [selectedManufacturer, setSelectedManufacturer] = useState<ManufacturerRecommendationForUser | null>(null);

  const confirmCustomRow = useCallback(() => {
    if (customItem && entityType && entityId && customItem.fetchedItem) {
      sendFetchedItem(
        customItem,
        entityType,
        entityId,
        setCustomRowButtonPressed,
        setSuccessResponse,
        addRoomCustomItem,
        addProjectCustomItem,
        addElectricalCustomItem,
        addNhcCustomItem,
        addRackCabinetCustomItem,
        addCableCustomItem,
        addConventionalDevicesCustomItem,
        addCustomSectionItem,
      );
    } else if (customItem && entityType && entityId) {
      let copyCustomItem = customItem;
      if(
        (!customItem.manufacturer_name ||
        customItem.manufacturer_name === "") &&
        selectedManufacturer !== null &&
        entityType !== 'projectcustomtable'
      ) {
        copyCustomItem = {
          ...customItem,
          internal_product_manufacturer_id: selectedManufacturer.internal_product_manufacturer_id,
          user_manufacturer_id: selectedManufacturer.user_manufacturer_id,
          manufacturer_name: selectedManufacturer.manufacturer_name,
        };
      }
      sendCustomItem(
        copyCustomItem,
        entityType,
        entityId,
        currency,
        setCustomRowButtonPressed,
        setSuccessResponse,
        addRoomCustomItem,
        addProjectCustomItem,
        addElectricalCustomItem,
        addNhcCustomItem,
        addCustomSectionItem,
      );
    }
  }, [
    customItem,
    entityType,
    entityId,
    customItem.fetchedItem,
    currency,
    dispatchDownloadStates,
    setCustomRowButtonPressed,
  ]);

  const handleChange = (event: any) => {
    const newCustomItem = Object.assign({}, customItem);
    setCustomItem({
      ...newCustomItem,
      [event.target.id]: event.target.value,
    });
  };

  useEffect(() => {
    if (successResponse) {
      setCurrentRowInEditing({});
    }
  }, [successResponse]);


  return hasPermissionForFuncInProject(
    "quote_sect.add_custom_product",
    params.projectId
  ) ? (
    <Fragment>
      <tr className="group group-start">
          <td colSpan={neededCols.length}>{ts("quote_custom", "Custom")}</td>
      </tr>
      <tr
          role="row"
          className="product-row custom-row"
          onMouseEnter={() => setShowTools(true)}
          onMouseLeave={() => setShowTools(false)}
          style={{ position: "relative" }}
      >
        {neededCols.map((col: any, key: any) => (
            <TableCell
                key={key}
                width={
                  col.data === "manufacturer_name" || col.data === "custom_description"
                      ? "200"
                      : "width" in col
                          ? col.width
                          : "auto"
                }
                numeric={col.numeric}
                cellCallback={col.cellCallback}
                style={{ position: "relative" }}
            >
              {col.data === "net_price" &&
              customItem &&
              customItem.fetchedItem &&
              customItem[`price_${currency}`] ? (
                  <div>
                    {formatPriceForcedCurrency(
                        customItem["price_" + currency],
                        currency
                    )}
                  </div>
              ) : col.data === "manufacturer_name" &&
              customItem &&
              customItem.fetchedItem &&
              customItem.manufacturer_name ? (
                  <div>{customItem.manufacturer_name}</div>
              ) : col.data === "article_number" &&
              customItem &&
              customItem.fetchedItem &&
              customItem.article_number ? (
                  <div>{customItem.article_number}</div>
              ) : col.data === "product_name" ? (
                  <Autocomplete
                      freeSolo
                      size="small"
                      options={customItemsForRecommendation}
                      getOptionLabel={(product: Product | string) =>
                          transformProductToOptions(product)
                      }
                      isOptionEqualToValue={(option: Product, value: Product) =>
                          option.product_id === value.product_id
                      }
                      renderInput={(params) => <TextField {...params} />}
                      onChange={(event, value: any) => {
                        if (value == null) {
                          setCustomItem({});
                        } else {
                          setCustomItem({
                            ...value,
                            net_price: value[`price_${currency}`],
                            quantity: 1,
                            fetchedItem: true,
                          });
                        }
                      }}
                      onInputChange={(event, value: any) => {
                        if (value == null) {
                          setCustomItem({});
                        } else {
                          setCustomItem({
                            ...customItem,
                            product_name: value,
                            fetchedItem: false,
                          });
                        }
                      }}
                  />
              ) : col.data === "manufacturer_name" ? (
                  <ManufacturerAutocomplete setSelectedManufacturer={setSelectedManufacturer} selectedManufacturer={selectedManufacturer}/>
              ) : (
                  <CustomCell
                      index={key + 1}
                      isNumeric={col.numeric ? col.numeric : false}
                      cellName={col.data}
                      placeholder={col.title}
                      handleChange={handleChange}
                      autoFocus={col.data === "product_name"}
                      confirmRow={confirmCustomRow}
                      cancelRow={cancelCustomRow}
                      customItem={customItem}
                      customItemsForRecommendation={customItemsForRecommendation}
                  />
              )}
            </TableCell>
        ))}

        {showTools ? (
            <RowTools
                cancelCustomRow={cancelCustomRow}
                confirmCustomRow={confirmCustomRow}
                minusRow={true}
            />
        ) : null}
      </tr>

    </Fragment>
  ) : null;
};

const transformProductToOptions = (customItem: Product | string) => {
  if (typeof customItem === 'string') {
    return customItem
  } else {
    return (customItem.product_name ?? '') + ' ' +
           (customItem.manufacturer_name ?? '') + ' ' +
           (customItem.color_name ?? '') + ' ' +
           (customItem.article_number ?? '') + ' ' +
           '(' + (customItem.product_id) + ')'
  }
}